import { ElementRef, Injectable } from '@angular/core';
import { interval, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InterstitialService {
  vm = this;
  clickEventActivatedSource: Subject<any> = new Subject<any>();
  inViewObserver: IntersectionObserver;

  clickEvent: any;

  constructor() {
    setTimeout(this._setListeners.bind(this), 1000);
  }

  getSubject() {
    return this.clickEventActivatedSource;
  }

  closeModal() {
    this.clickEventActivatedSource.next(null);
  }

  getFormattedLink() {
    let rawLink = '###';
    if (this.clickEvent && this.clickEvent.target) {
      rawLink = this.clickEvent.target.href;
    }

    const splitReference = rawLink.split('#');

    return splitReference[2];
  }

  _callListeners() {
    this.clickEventActivatedSource.next(this.getFormattedLink());
  }

  _setListeners() {
    const elements = document.querySelectorAll('a');
    for (const elementIndex in elements) {
      if (elements.hasOwnProperty(elementIndex)) {
        const element = elements[elementIndex];
        if (element && element.href && element.href.includes('#interstitialNewPageConfirmation')) {
          element.addEventListener('click', (e) => {this._handleClick(e); });
        }
      }
    }
  }

  _handleClick(e) {
    e.preventDefault();
    this.clickEvent = e;
    this._callListeners();
  }
}
